import SubscribeButton from './buttons/SubscribeButton'
import lockIcon from '/web/asset/aifans/subscribe-to-unlock-lock.png'

interface Props {
  onSubscribe: () => void
  subscribing: boolean
  modelName?: string
}

const SubscribeToUnlock = (props: Props) => {
  return (
    <div class="relative md:mx-auto ">
      <div class="mx-2.5 my-6 rounded-lg bg-[#0C0F12]/30 px-5 py-5 md:my-12 md:max-w-4xl md:px-36 md:py-8">
        <div class="flex items-center md:justify-center">
          <img src={lockIcon} class="mb-1 w-4 md:mb-3 md:w-7" />
          <div class="ml-3 font-clash text-2xl font-bold md:ml-4 md:mr-0 md:text-[40px] md:leading-[50px]">
            Subscribe To Unlock!
          </div>
        </div>
        <div class="mt-5 text-center font-clash text-xl text-[#E6E6E6]">
          <div>Enjoy full access to {props.modelName} and all her censored content! </div>

          <div class="mx-auto md:w-2/3">
            <SubscribeButton onSubscribe={props.onSubscribe} subscribing={false} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubscribeToUnlock
